import blueMarkerSvg from '../../images/blueMarker.svg';
import redMarkerSvg from '../../images/redMarker.svg';

export const redMarker = {
  url: redMarkerSvg,
  scaledSize: { width: 36, height: 36 },
};

export const blueMarker = {
  url: blueMarkerSvg,
  scaledSize: { width: 48, height: 48 },
};
